import { h, Component } from 'preact';

import getStore, { appState$ } from '../store';
import { map } from 'rxjs/operators';

import { DataDisplayWidget } from './common/data-display.widget';
import { BrokerLeaderboardWidget } from './dashboard/broker-leaderboard.widget';
import { BrokerLeaderboard } from '../../../types/broker-leaderboard.model';
import { PotentialCommissionWidget } from './dashboard/potential-commission.widget';
import { OfflineListingEditorWidget } from './listings/offline-listings-editor.widget';
import { MiniListing, Listing } from '../../../types/listing.model';
import { TopFiveListingsWidget, RANK_BY_VIEWS, RANK_BY_INQUIRIES } from './listings/top-five-listings.widget';
import { DashboardAction, GET_DASHBOARD_DATA, GET_BROKER_LEADERBOARD_DATA } from '../reducers/dashboard/dashboard.actions';

import { DashboardMetricData, PotentialCommission } from '../../../types/dashboard.model';
import { Subscription } from 'rxjs';
import { PopularByInquiries } from './dashboard/popular-by-inquiries.widget';
import { ListingAction, GET_LISTING_DATA } from '../reducers/listing/listing.actions';

export interface KumitaDashboardProps {
}

export interface KumitaDashboardState {
  metricData?: DashboardMetricData;

  rentalPotentialCommission?: PotentialCommission;
  salePotentialCommission?: PotentialCommission;

  brokerLeaderboard?: BrokerLeaderboard[];

  offlineListings?: Listing[];

  topListingsByInquiries?: Listing[];
  topListingsByViews?: Listing[];
}

export class KumitaDashboard extends Component<any, KumitaDashboardState> {
  sampleMiniListings: MiniListing[];

  subs: Subscription[] = [];

  locations: string[] = [
    'Dasmarinas Village',
    'McKinley Hill',
    'Alabang',
    'Legaspi Village',
    'Rockwell',
    'Salcedo Village',
    'Urdaneta',
    'BF Homes - Paranaque',
    'San Lorenzo Village',
    'Merville',
    'Valle Verde'
  ];


  initialOfflineStage: string = 'pending';

  constructor(props) {
    super(props);

    // I'll be initializing placeholder data here for ease of dev

    this.sampleMiniListings = [];
    let mini: MiniListing;
    let coinFlip: boolean;
    let price: number;
    for (let b = 0; b < 10; b++) {
      coinFlip = this.coinFlip();
      if (coinFlip) {
        price = Math.floor(Math.random() * 10000000);
      } else {
        price = Math.floor(Math.random() * 100000);
      }

      mini = {
        propertyKey: `R${coinFlip ? 'S' : 'R'}${Math.floor(Math.random() * 999999)}${b}`,
        type: 'Condominium',
        category: coinFlip ? 'Sale' : 'Rent',
        minPrice: price,
        address: '12345, Somewhere Condo, StoneWall Village, Makati'
      };

      this.sampleMiniListings.push(mini);
    }

  }

  componentDidMount() {
    const dashboard$ = appState$.pipe(
      map(app => app.dashboard)
    );

    const listing$ = appState$.pipe(
      map(app => app.listing)
    );

    this.subs.push(
      dashboard$.pipe(
        map(dashboard => dashboard.metricData)
      ).subscribe(metricData => {
        if (metricData) {
          this.setState({
            metricData: metricData
          })
        }
      })
    );

    this.subs.push(
      dashboard$.pipe(
        map(dashboard => dashboard.salePotentialCommission)
      ).subscribe(salePotentialCommission => {
        if (salePotentialCommission) {
          this.setState({
            salePotentialCommission: salePotentialCommission
          })
        }
      })
    );

    this.subs.push(
      dashboard$.pipe(
        map(dashboard => dashboard.rentalPotentialCommission)
      ).subscribe(rentalPotentialCommission => {
        if (rentalPotentialCommission) {
          this.setState({
            rentalPotentialCommission: rentalPotentialCommission
          })
        }
      })
    );

    this.subs.push(
      dashboard$.pipe(
        map(dashboard => dashboard.rentalPotentialCommission)
      ).subscribe(rentalPotentialCommission => {
        if (rentalPotentialCommission) {
          this.setState({
            rentalPotentialCommission: rentalPotentialCommission
          })
        }
      })
    );

    this.subs.push(
      dashboard$.pipe(
        map(dashboard => dashboard.brokerLeaderboard)
      ).subscribe(brokerLeaderboard => {
        if (brokerLeaderboard) {
          this.setState({
            brokerLeaderboard: brokerLeaderboard
          })
        }
      })
    );

    this.subs.push(
      dashboard$.pipe(
        map(dashboard => dashboard.topListingsByInquiries)
      ).subscribe(topListingsByInquiries => {
        if (topListingsByInquiries) {
          this.setState({
            topListingsByInquiries: topListingsByInquiries
          })
        }
      })
    );

    this.subs.push(
      dashboard$.pipe(
        map(dashboard => dashboard.topListingsByViews)
      ).subscribe(topListingsByViews => {
        if (topListingsByViews) {
          this.setState({
            topListingsByViews: topListingsByViews
          })
        }
      })
    );

    this.subs.push(
      listing$.pipe(
        map(listing => listing.listings)
      ).subscribe(listings => {
        this.setState({
          offlineListings: listings
        });
      })
    ); 

    this.initialStoreDispatches();
  }

  initialStoreDispatches() {

    const store = getStore();

    const getDashboardData: DashboardAction = {
      type: GET_DASHBOARD_DATA
    }

    const getBrokerLeaderboardData: DashboardAction = {
      type: GET_BROKER_LEADERBOARD_DATA
    }

    const getOfflineListingsData: ListingAction = {
      type: GET_LISTING_DATA,
      payload: {
        gridStage: this.initialOfflineStage
      }
    }

    store.dispatch(getDashboardData);
    store.dispatch(getBrokerLeaderboardData);
    store.dispatch(getOfflineListingsData);

  }

  componentWillUnmount() {
    this.subs.forEach(s => s.unsubscribe());
  }

  coinFlip(): boolean {
    const num = Math.floor(Math.random()* 10);
  
    return num % 2 == 0;
  }

  getListingCountBlock(state: KumitaDashboardState) {
    if (state.metricData) {
      return (
        <DataDisplayWidget 
          name="Number of Listings"
          data1={ state.metricData.listingCount }
          data1Label="Your Listings (Offline and Online)"
          data2={ state.metricData.avgListingCount }
          data2Label="Ave. Number of Listings (Top 20 Brokers)"    
          externalLink="/kumita-brokers/listings"
          changeAmount={50}
          isChangePositive={true}         
        />
      );
    }
  }

  getListingViewCountBlock(state: KumitaDashboardState) {
    if (state.metricData) {
      return (
        <DataDisplayWidget 
          name="Number of Views"
          data1={ state.metricData.viewsCount }
          data1Label="Views on Your listings"
          data2={ state.metricData.avgViewsCount }
          data2Label="Ave. Number of Views (Top 20 Brokers)"
          changeAmount={37}
          isChangePositive={false}   
        />
      );
    }
  }

  getInquiriesCountBlock(state: KumitaDashboardState) {
    if (state.metricData) {
      return (
        <DataDisplayWidget 
          name="Number of Inquiries"
          data1={ state.metricData.inquiriesCount }
          data1Label="Inquiries on Your Listings"
          data2={ state.metricData.avgInquiriesCount }
          data2Label="Ave. Number of Inquiries (Top 20 Brokers)"
          externalLink="/somewhere"                
        />
      );
    }
  }

  getPotentialCommission(state: KumitaDashboardState) {
    
    if (state.salePotentialCommission && state.rentalPotentialCommission) {
      return (
        <PotentialCommissionWidget 
          salePotentialCommission={ state.salePotentialCommission }
          rentalPotentialCommission={ state.rentalPotentialCommission }/>
      );
    }
  }

  getBrokerLeaderboardBlock(state: KumitaDashboardState) {

    if (state.brokerLeaderboard) {
      return (
        <div className="col-12 col-md-6 col-lg-12">
          <BrokerLeaderboardWidget brokers={ state.brokerLeaderboard } />
        </div>
      );
    }

  }

  render(props: KumitaDashboardProps, state: KumitaDashboardState) {
    return (
      <div className="hi-kumita__dashboard">
        <div className="container-fluid">
          <div className="row">
            {/* cookie crumbs */}

            <div className="col-8 col-lg-4">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item"><a href="#">Dashboard</a></li>
                  <li className="breadcrumb-item active" aria-current="page">Listing Updates</li>
                </ol>
              </nav>
            </div>


            <div className="col-4 col-lg-2 offset-lg-6 d-flex justify-content-end align-items-center">
              {/* <a className="hi-kumita__dashboard__faq" href="#">
                FAQs <i className="fas fa-chevron-right"></i>
              </a> */}
            </div>
          </div>

          <div className="row justify-content-center">
            {/* listing/inquiry tab changers */}

            <div className="col-12 col-lg-4 d-flex justify-content-center">
              <button className="btn hi-kumita__dashboard__tab active">
                Listing Updates
              </button>
              <button className="btn hi-kumita__dashboard__tab" disabled={true}>
                Inquiry Updates
              </button>
            </div>

          </div>

          <div className="row mt-4">
            {/* broker tips | Note, the mt-4 on this row and the mt-2 on the element help stack */}

            <div className="col-12">
              <div className="hi-kumita__dashboard__tips mt-2">
                Broker Tips: Hoppler provides you 30% more quality leads. Go to FAQs to learn more.
              </div>
            </div>
          </div>

          <div className="row mt-5">
            {/* Left of dashboard content */}
            <div className="col-12 col-lg-8 hi-kumita__dashboard__widget-column">

              <div className="row">
                <div className="col-12 col-md-6">
                  { this.getListingCountBlock(state) }
                </div>
                <div className="col-12 col-md-6 mt-4 mt-md-0">
                  { this.getListingViewCountBlock(state) }
                </div>
              </div>

              <div className="row mt-4 mt-xl-5">
                <div className="col-12 col-md-6">
                  { this.getInquiriesCountBlock(state) }
                </div>
                <div className="col-12 col-md-6 mt-4 mt-md-0">
                  <DataDisplayWidget isComingSoon={true}
                    name="Number of Active Deals"
                    data1={0}
                    data1Label="Your Current Active Deals"
                    data2={0}
                    data2Label="Ave. Number of Inquiries (Top 20 Brokers)"                
                  />
                </div>
              </div>
            
              <div className="row mt-4 mt-xl-5">
                <div className="col-12">
                  { this.getPotentialCommission(state) }
                </div>

                <div className="col-12 col-lg-6 mt-4 mt-xl-5">
                  <TopFiveListingsWidget 
                    title="Your Top 5 Listings by Views"
                    rankedBy={ RANK_BY_VIEWS }
                    listings={ state.topListingsByViews } 
                    hrefText="Learn how to get more views on your listings"
                    hrefLink="#"/>
                </div>

                <div className="col-12 col-lg-6 mt-4 mt-xl-5">
                  <TopFiveListingsWidget 
                    title="Your Top 5 Listings by Inquiries"
                    rankedBy={ RANK_BY_INQUIRIES }
                    listings={ state.topListingsByInquiries } 
                    hrefText="Learn how to get more inquiries on your listings"
                    hrefLink="#"/>
                </div>
              </div>

            </div>

            <div className="col-12 col-lg-4 mt-4 mt-lg-0">
              <div className="row">
                { this.getBrokerLeaderboardBlock(state) }
                {
                  state.offlineListings ? 
                  <div className="col-12 col-md-6 col-lg-12 mt-4 mt-md-4 mt-xl-5">
                    <OfflineListingEditorWidget
                      initialStage={ this.initialOfflineStage }
                      listings={ state.offlineListings } />
                  </div> : null
                }
              </div>

              <div className="row">
                <div className="col-12 mt-4 mt-md-4 mt-xl-5">
                  <PopularByInquiries
                    isComingSoon={true} 
                    locations={this.locations}/>
                </div>
              </div>
              
            </div>
          </div>
        </div>

      </div>
    );
  }

}